package com.essntl.core.utils.utils.windowmanager

import org.koin.dsl.module

val windowManagerModule
    get() =
        module {
            single<WindowManager> { WindowMangerImpl() }
        }